import { render } from "./wearables.vue?vue&type=template&id=6804d1f0&scoped=true"
import script from "./wearables.vue?vue&type=script&lang=js"
export * from "./wearables.vue?vue&type=script&lang=js"

import "./wearables.vue?vue&type=style&index=0&id=6804d1f0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6804d1f0"]])

export default __exports__